import { defineComponent as H, computed as b, ref as E, watch as U, createElementBlock as w, openBlock as m, createVNode as V, unref as f, withCtx as p, createBlock as P, createCommentVNode as j, Fragment as z, renderList as X, renderSlot as J, mergeProps as g, toHandlers as B, createTextVNode as Q, toDisplayString as W } from "vue";
import "@popperjs/core";
import { RevInputText as Z } from "@ds/components/InputText";
import { RevList as x } from "@ds/components/List";
import { RevListItemInteractive as ee } from "@ds/components/ListItemInteractive";
import { RevPopover as te } from "@ds/components/Popover";
import { isEmpty as y } from "../../utils/isEmpty.js";
import { tw as C } from "../../utils/tailwind.js";
import { OPTIONS_MAX_LENGTH as re, NO_ACTIVE_OPTION as c } from "./InputAutocomplete.constant.js";
const oe = { class: "relative" }, fe = /* @__PURE__ */ H({
  name: "RevInputAutocomplete",
  inheritAttrs: !1,
  __name: "InputAutocomplete",
  props: {
    clearButtonAriaLabel: {},
    description: { default: void 0 },
    error: { default: void 0 },
    helperTextClass: { type: [String, Boolean, Array, Object], default: C`mt-8` },
    icon: { default: void 0 },
    id: {},
    label: {},
    listboxPlacement: { default: "auto" },
    options: {},
    modelValue: {},
    required: { type: Boolean, default: !1 },
    type: { default: "text" }
  },
  emits: ["update:model-value", "select-item", "focus", "blur", "input", "clear"],
  setup(L, { emit: O }) {
    const u = L, i = O, v = b(
      () => u.options.slice(0, re)
    );
    function N(e) {
      return `${u.id}-option-${e}`;
    }
    const l = E(c), I = E(!1), h = b(() => `${u.id}-listbox`);
    function s(e) {
      return e && !y(u.options);
    }
    const k = b({
      get() {
        return u.modelValue;
      },
      set(e) {
        i("update:model-value", e);
      }
    });
    function F(e) {
      if (!(!s(e) || l.value === c))
        return N(l.value);
    }
    U(v, (e) => {
      l.value = y(e) ? c : Math.min(l.value, e.length - 1);
    });
    function S(e, t) {
      t(), i("focus", e);
    }
    function K(e, t) {
      I.value || t(), i("blur", e);
    }
    function _(e) {
      l.value = c, i("input", e);
    }
    function M() {
      i("clear");
    }
    function d(e, t, o, r) {
      if (y(u.options))
        return;
      if (e.preventDefault(), !s(r)) {
        o();
        return;
      }
      const { length: a } = v.value;
      if (t === Number.NEGATIVE_INFINITY) {
        l.value = 0;
        return;
      }
      if (t === Number.POSITIVE_INFINITY) {
        l.value = a - 1;
        return;
      }
      if (l.value === c) {
        l.value = t < 0 ? a - 1 : 0;
        return;
      }
      l.value = (l.value + a + t) % a;
    }
    function R(e) {
      e();
    }
    function $(e, t, o) {
      const r = u.options[l.value];
      !r || !s(o) || (e.preventDefault(), i("select-item", r, u.id, l.value), t());
    }
    function q(e, t, o, r) {
      switch (e.key) {
        case "ArrowDown":
          d(e, 1, t, r);
          break;
        case "PageDown":
        case "End":
          d(e, Number.POSITIVE_INFINITY, t, r);
          break;
        case "ArrowUp":
          d(e, -1, t, r);
          break;
        case "PageUp":
        case "Home":
          d(e, Number.NEGATIVE_INFINITY, t, r);
          break;
        case "Escape":
          R(o);
          break;
        case "Enter":
          $(e, o, r);
          break;
      }
    }
    function D(e) {
      l.value = e;
    }
    function Y() {
      I.value = !0;
    }
    async function G(e, t, o, r, a) {
      e.preventDefault(), i("select-item", t, o, r), a(), I.value = !1;
    }
    function T({ index: e }) {
      return {
        id: N(e),
        index: e,
        role: "option",
        class: e === l.value && C`bg-static-default-min-hover`
      };
    }
    function A({
      index: e,
      option: t,
      hide: o
    }) {
      return {
        click: (r) => G(r, t, u.id, e, o),
        mousedown: () => Y(),
        mousemove: () => D(e)
      };
    }
    return (e, t) => (m(), w("div", oe, [
      V(f(te), {
        "content-class-names": "z-10 w-full",
        position: e.listboxPlacement,
        "trigger-element-id": e.id
      }, {
        trigger: p(({ show: o, hide: r, isOpen: a }) => [
          V(f(Z), g({ id: e.id }, e.$attrs, {
            modelValue: k.value,
            "onUpdate:modelValue": t[0] || (t[0] = (n) => k.value = n),
            "aria-activedescendant": F(a),
            "aria-autocomplete": "list",
            "aria-controls": h.value,
            "aria-expanded": String(s(a)),
            autocomplete: "off",
            "clear-button-aria-label": e.clearButtonAriaLabel,
            description: e.description,
            error: e.error,
            "helper-text-class": e.helperTextClass,
            icon: e.icon,
            label: e.label,
            required: e.required,
            role: "combobox",
            type: e.type,
            onBlur: (n) => K(n, r),
            onClear: M,
            onFocus: (n) => S(n, o),
            onInput: _,
            onKeydown: (n) => q(n, o, r, a)
          }), null, 16, ["id", "modelValue", "aria-activedescendant", "aria-controls", "aria-expanded", "clear-button-aria-label", "description", "error", "helper-text-class", "icon", "label", "required", "type", "onBlur", "onFocus", "onKeydown"])
        ]),
        content: p(({ hide: o, isOpen: r }) => [
          s(r) ? (m(), P(f(x), {
            key: 0,
            id: h.value,
            class: "bg-overlap-default-low shadow-long rounded-sm mt-4 overflow-hidden",
            "has-external-borders": !1,
            role: "listbox"
          }, {
            default: p(() => [
              (m(!0), w(z, null, X(v.value, (a, n) => J(e.$slots, "default", g({ ref_for: !0 }, {
                ...a,
                ...T({ index: n })
              }, B(A({ option: a, index: n, hide: o }), !0)), () => [
                (m(), P(f(ee), g({
                  key: a.key
                }, { ref_for: !0 }, T({ index: n }), B(A({ option: a, index: n, hide: o }))), {
                  label: p(() => [
                    Q(W(a.label), 1)
                  ]),
                  _: 2
                }, 1040))
              ])), 256))
            ]),
            _: 2
          }, 1032, ["id"])) : j("", !0)
        ]),
        _: 3
      }, 8, ["position", "trigger-element-id"])
    ]));
  }
});
export {
  fe as default
};
